// Apple emoji — innernet renders hand-picked emoji as Apple's own artwork
// (PNGs from the emoji-datasource-apple package, served by jsdelivr), so a
// folder's icon looks IDENTICAL on macOS, Windows, Android, Linux — never the
// platform's own emoji font. The stored symbol stays the native emoji char
// (schema-compatible with the glyph override everywhere); only the RENDER
// swaps in Apple's image.

export const APPLE_EMOJI_VERSION = "15.1.2";
export const APPLE_EMOJI_CDN = `https://cdn.jsdelivr.net/npm/emoji-datasource-apple@${APPLE_EMOJI_VERSION}`;

/** hex codepoints of an emoji char, surrogate-safe ("❤️" → ["2764","fe0f"]). */
export function emojiCodepoints(emoji: string): string[] {
  return [...emoji].map((c) => c.codePointAt(0)!.toString(16));
}

/**
 * Candidate Apple image URLs for a raw emoji char. emoji-datasource names files
 * by its `unified` field, which sometimes carries the FE0F variation selector
 * and sometimes not — try the exact spelling first, then the bare one; the
 * renderer falls back to the native glyph if neither resolves.
 */
export function appleEmojiUrls(emoji: string): string[] {
  const cps = emojiCodepoints(emoji);
  if (!cps.length) return [];
  const full = cps.join("-");
  const bare = cps.filter((c) => c !== "fe0f").join("-");
  const urls = [`${APPLE_EMOJI_CDN}/img/apple/64/${full}.png`];
  if (bare && bare !== full) urls.push(`${APPLE_EMOJI_CDN}/img/apple/64/${bare}.png`);
  return urls;
}

/** "1f600" / "2764-fe0f" → the native emoji char. */
export function unifiedToNative(unified: string): string {
  return String.fromCodePoint(...unified.split("-").map((h) => parseInt(h, 16)));
}
